import { Stack, Tab, Tabs } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import PageLayout from '@shared/shell/Layout/PageLayout';
import { PurchaseOrderOnboardingOverlay } from '@features/tutorial';
import Purchasing from './Purchasing';
import Shipments from '@features/shipments/components/Shipments';

enum PageTab {
  PURCHASE_ORDERS = 'purchase-orders',
  SHIPMENTS = 'shipments',
}

const PurchasingLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tab =
    location.pathname === '/purchasing/shipments' ? PageTab.SHIPMENTS : PageTab.PURCHASE_ORDERS;

  const handleTabChange = (_: React.SyntheticEvent, value: PageTab) => {
    if (value === PageTab.SHIPMENTS) {
      navigate('/purchasing/shipments');
    } else {
      navigate('/purchasing');
    }
  };

  return (
    <PageLayout title="Purchasing">
      {tab === PageTab.PURCHASE_ORDERS && <PurchaseOrderOnboardingOverlay />}
      <Stack borderBottom={1} borderColor="divider">
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab sx={{ textTransform: 'none' }} label="Purchase orders" value={PageTab.PURCHASE_ORDERS} />
          <Tab sx={{ textTransform: 'none' }} label="Shipments" value={PageTab.SHIPMENTS} />
        </Tabs>
      </Stack>

      {tab === PageTab.PURCHASE_ORDERS && <Purchasing />}
      {tab === PageTab.SHIPMENTS && <Shipments />}
    </PageLayout>
  );
};

export default PurchasingLayout;
